import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StoresService } from 'src/app/home/services/stores.service';

@Component({
  selector: 'app-mark-consume-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './mark-consume-modal.component.html',
  styleUrls: ['./mark-consume-modal.component.scss', '../../../app.component.scss', '../../../shared/base-modal.style.scss']
})
export class MarkConsumeModalComponent implements OnInit{
  public dialogData: any;
  public stores = [];
  public selectedStore: { 
    id: string|number,
    name: string
  } = {
    id: "",
    name: ""
  };

  constructor(
    public dialogRef: MatDialogRef<MarkConsumeModalComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private storeService: StoresService
  ){
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    this.getStores();
  }

  getStores(){
    let currentUserRole = JSON.parse(localStorage.getItem('role'));

    this.storeService.getStores(currentUserRole.resource_id, ['id', 'name']).subscribe({
      next: (res) => {
        if (res.data.length !== 0) {
          this.stores = res.data;          
          this.selectedStore = this.stores.find((store) => store.id == this.dialogData.storeId);
        }
      },
      error: (error) => {
        if (error) {
        }
      },
      complete: () => {return} 
    });
  }

  openStoresDropdown(event){
    let popupDiv = document.getElementById("stores-dropdown");

    if (!popupDiv.className.includes("active")) {
      popupDiv.classList.add("active");
      event.stopPropagation()
      this.closePopupOutside("stores-dropdown");
    }
  }

  onStoreChange(store: { id: number, name: string }){
    this.selectedStore = store;
  }

  consume(){
    let bodyContent = {
      implant_id: [this.dialogData.implantId],
      store_id: this.selectedStore.id
    }

    this.storeService.consumeImplants(this.dialogData.storeId, bodyContent).subscribe({
      next: (res) => {
        if (res.data) {
          if (res.data.updated_products.length !== 0) {
            this.dialogRef.close({ status: true, message: 'Product status has been updated successfully'});
          }else if(res.data.nonUpdated_products.length !== 0){
            this.dialogRef.close({ status: false, message: "Something went wrong can't update the product."});
          }else if(res.data.consumed_products.length !== 0){
            this.dialogRef.close({ status: false, message: "This product was already consumed."});
          }else if(res.data.expired_products.length !== 0){
            this.dialogRef.close({ status: false, message: "This product was expired."});
          }
        }else{
          this.dialogRef.close({ status: false, message: "Oops something went wrong."});
        }
      },
      error: (error) => {
        if (error) {
          this.dialogRef.close({ status: false, message: "Oops something went wrong."});
        }
      },
      complete: () => {return} 
    });
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active")
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
